import { render, staticRenderFns } from "./NotificationIndex.vue?vue&type=template&id=6ecb2f41&scoped=true&"
import script from "./NotificationIndex.vue?vue&type=script&lang=js&"
export * from "./NotificationIndex.vue?vue&type=script&lang=js&"
import style0 from "./NotificationIndex.vue?vue&type=style&index=0&id=6ecb2f41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecb2f41",
  null
  
)

export default component.exports